// extracted by mini-css-extract-plugin
export default {"text":"Moto_text__8QuIU","marquee":"Moto_marquee__Eoiib"};